<template>
  <div class="house-importer-import-payments-panel">
    <app-panel title="Добавление платежей">
      <div slot="actions">
        <app-button v-if="status === IMPORT_STATUSES.default" color="success" @click="sendFile">Добавить</app-button>
        <app-button v-if="status === IMPORT_STATUSES.send" color="success" @click="resetImport">Добавить еще
        </app-button>
      </div>

      <div class="house-importer-import-payments-panel__content">
        <div class="house-importer-import-payments-panel__main-content" v-if="IMPORT_STATUSES.default === status">
          <div class="house-importer-import-payments-panel__col house-importer-import-payments-panel__col_file">
            <div class="house-importer-import-payments-panel__no-file-error" v-if="fileError">
              Выберите файл
            </div>
            <vs-upload
                    action="#"
                    :limit="1"
                    :show-upload-button="false"
                    text="Добавить файл"
                    @change="onFileChange"
                    @on-delete="onFileDelete"
                    class="import-source-stage__uploader import-source-stage__uploader_single"
                    ref="counterUploader"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
          <div class="house-importer-import-payments-panel__col house-importer-import-payments-panel__col_settings">
            <div class="house-importer-import-payments-panel__col-row">
              <app-input label="Номер листа с платежами"
                         vtype="uint"
                         v-model="postBody.payments_list"
                         :danger.sync="postBodyErrors.payments_list"
                         danger-text="Заполните номер листа"
              />
            </div>
          </div>
        </div>
        <div class="house-importer-import-payments-panel__loading" v-else-if="IMPORT_STATUSES.sending === status">
          <div class="block-loading"/>
          <div>Импортируем платежи...</div>
        </div>
        <div class="house-importer-import-payments-panel__done" v-else-if="IMPORT_STATUSES.send === status">
          <div class="house-importer-import-payments-panel__done-icon">
            <app-icon name="CheckIcon" size="120px"/>
          </div>
          <div class="house-importer-import-payments-panel__done-text">
            Файл импортирован

            <div class="house-importer-import-payments-panel__done-sub-text">
              Добавлено платежей: {{importedPayments}} <div class="link-icon house-importer-import-payments-panel__done-sub-text-icon" v-if="importedPaymentsMismatches.length" @click="isImportedPaymentsMismatchesPopupOpen = true"><app-icon name="InfoIcon2" size="18px"/></div>
            </div>

          </div>
        </div>
      </div>

      <app-popup :active.sync="isImportedPaymentsMismatchesPopupOpen" title="Разница между тем что надо было импортировать и импортировалось">
        <div>
          <vs-table :data="importedPaymentsMismatches" hoverFlat
                    class="house-importer-import-payments-panel__table"
                    no-data-text="Данных нет">
            <template slot="thead">
              <vs-th>Аккаунт</vs-th>
              <vs-th>Разница</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="`${trIndex}`" v-for="(tr, trIndex) in data">
                <vs-td>{{tr.account_number}}</vs-td>
                <vs-td>{{tr.diff | numberWithSpaces}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </app-popup>
    </app-panel>
  </div>
</template>

<script>
  const IMPORT_STATUSES = {
    default: 0,
    sending: 1,
    send: 2
  };

  export default {
    name: "ImportPaymentsPanel",
    props: {
      importInfo: {},
    },
    data() {
      return {
        IMPORT_STATUSES: IMPORT_STATUSES,
        status: IMPORT_STATUSES.default,
        importedPayments: 0,
        fileError: false,
        file: null,
        postBody: {
          payments_list: null
        },
        postBodyErrors: {
          payments_list: false
        },
        importedPaymentsMismatches: [],
        isImportedPaymentsMismatchesPopupOpen: false
      }
    },
    computed: {
      postBodyHasError(){
        return !!Object.values(this.postBodyErrors).filter(v => v).length;
      }
    },
    methods: {
      resetPostBodyErrors(){
        this.postBodyErrors.payments_list = false;
      },
      resetPostBody(){
        this.postBody.payments_list = null;
      },
      resetImport() {
        this.resetPostBodyErrors();
        this.resetPostBody();
        this.status = IMPORT_STATUSES.default;
        this.importedPayments = 0;
        this.importedPaymentsMismatches = [];
      },
      checkPostBody(){
        if(this.postBody.payments_list === null){
          this.postBodyErrors.payments_list = true;
        }
      },
      checkFileError(){
        if(this.file === null){
          this.fileError = true;
        }
      },
      onFileChange(event, files){
        this.file = files.filter(file => !file.remove)[0] || null;
        this.fileError = false;
      },
      onFileDelete(){
        this.file = null;
        this.fileError = false;
      },
      async sendFile() {
        this.resetPostBodyErrors();
        this.checkPostBody();
        this.checkFileError();

        if(this.postBodyHasError || this.fileError) return false;

        this.status = IMPORT_STATUSES.sending;

        try {
          let body = Object.assign({import_id: this.importInfo.id, new_invoices: this.file}, this.postBody);

          let bodyFormData = new FormData();

          for(let key in body){
            if(body.hasOwnProperty(key)){
              if(Array.isArray(body[key])){
                for(let i = 0; i < body[key].length; i++){
                  bodyFormData.append(`${key}[${i}]`, body[key][i]);
                }
              }
              else{
                bodyFormData.append(key, body[key])
              }
            }
          }
          let {data} = await this.$http.post('import/houses/latest_invoices', bodyFormData, {
            headers: {
              'Content-Type': 'multipart/form-data;'
            }
          });
          this.importedPayments = data.inserted;
          this.importedPaymentsMismatches = data.sum_mismatches;
          setTimeout(() => {
            this.status = IMPORT_STATUSES.send;
          }, 300);
        } catch (e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.resetImport();
        }

      }
    }
  }
</script>

<style lang="scss">
  .house-importer-import-payments-panel {

    &__content {
      height: 200px;
      position: relative;
    }

    &__main-content{
      display: flex;
      margin: 0 -7.5px;
      height: 100%;
    }

    &__col{
      padding: 0 7.5px;
      flex: 1;


      &_file{
        display: flex;
        max-width: 40%;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      &_settings{
        width: 60%;
        border-left: 1px solid rgba(0, 0,0, .2);
      }
    }

    .import-source-stage__uploader_single{
      height: auto;
    }

    .con-img-upload{
      margin: 0 auto;
      width: 150px;
      height: 150px;
    }

    &__no-file-error{
      text-align: center;
      color: rgba(var(--app-danger), 1);
      margin-bottom: 5px;
      font-weight: 500;
    }

    .con-img-upload .img-upload{
      margin: 0 -.6em;
      width: 150px;
      height: 150px;
    }

    &__loading {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .block-loading {
        width: 60px;
        height: 60px;
        flex: 0;
        margin-bottom: 15px;
      }
    }

    &__done {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: rgba(var(--app-success), 1);

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-text {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }

      &-sub-text {
        font-size: 16px;
        display: flex;
        align-items: center;
        line-height: 1.1;

        &-icon{
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: -2px;
        }

      }
    }
    &__table {
      .vs-table--tbody {
        border: none;
        background: #fff;
      }

      .vs-table--thead th {
        padding: 0 !important;
        border-bottom: 1px solid rgba(0, 0, 0, .125);

        .vs-table-text {
          text-align: left;
          position: relative;
          vertical-align: bottom;
          padding: .75rem 10px;
          background: transparent;
          font-size: 12px;
        }
      }

      .vs-table {
        .vs-table--tr:nth-child(2n+1) {
          background: #f5f8fa;
        }
      }

      .tr-values td {
        padding: .5rem 10px;
        font-size: 12px;
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>